const FILTER_HOTSPOTS_EVENT = 'filter-hotspots';

// Store the last emitted value for replay
let lastEmittedValue = null;

/**
 * Emit event to filter hotspots by IDs
 * @param {Array<string>|null} hotspotIds - List of hotspot IDs to show, null to show all
 */
export const emitFilterHotspots = (hotspotIds) => {
  lastEmittedValue = hotspotIds;
  const event = new CustomEvent(FILTER_HOTSPOTS_EVENT, {
    detail: { hotspotIds },
  });
  window.dispatchEvent(event);
};

/**
 * Subscribe to listen for hotspot filter changes
 * @param {Function} callback - Callback receives hotspotIds array or null
 * @param {boolean} replay - If true, immediately calls callback with last emitted value
 * @returns {Function} Unsubscribe function
 */
export const subscribeFilterHotspots = (callback, replay = false) => {
  // Immediately replay last emitted value if requested
  if (replay && lastEmittedValue !== null) {
    callback(lastEmittedValue);
  }

  const handler = (event) => {
    const { hotspotIds } = event.detail || {};
    callback(hotspotIds ?? null);
  };

  window.addEventListener(FILTER_HOTSPOTS_EVENT, handler);

  return () => {
    window.removeEventListener(FILTER_HOTSPOTS_EVENT, handler);
  };
};
